import Header from "../../Home/Header";
import Footer from "../../Home/Footer";

function Louvain () {
  return (
    <div className="core">
      <Header />
      <h2 className="bloc titre">Charles-Quint et les étudiants de Louvain</h2>
      <div className="bloc">
        <p>Charles-Quint aimait à se déguiser pour parcourir à cheval son incommensurable empire afin de mieux connaître les activités de ses concitoyens.</p>
        <p>En visite à Louvain, où des étudiants festoyaient joyeusement, il vit que l’heure tardive n’empêchait personne de faire la fête et de boire généreusement.</p>
        <p>Charles-Quint n’étant jamais effrayé à l’idée de boire une bonne bière, il se rendit dans une auberge du Oude Markt.</p>
        <p>Au moment où il ouvrit la porte, un homme vola dehors. Charles-Quint vit tout de suite qu’il était saoul et l’aida à se relever sur ses deux jambes chancelantes.</p>
        <p>« Sept hommes m’ont battu » hurla l’infortuné. Charles-Quint hurla à son tour : « Justice sera faite, je vais les éjecter tous les sept  ». « Compte-les », dit-il au saoulard avant de se ruer à l’intérieur.</p>
        <p>Après un vacarme inouï, un homme vola par la fenêtre.</p>
        <p>« Un ! » cria le poivrot.</p>
        <p>« Arrête de compter » dit l’empereur, en comptant ses bleus, ses bosses et ecchymoses. Et il ajouta : « Je pense que les six autres ne viendront plus ».</p>
        <div className="legende">
          <p>©http://www.charlesquint.be/#initialize</p>
        </div>
      </div>
      <Footer />
    </div>
  )
}
export default Louvain